import { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import CustomListItem from 'components/List/ListItem/ListItem';
import { StatusChip } from 'components/Dropdown/AssigneeDropdown/listItems/utils';
import { StyledName, Title } from './style';
import TeamsList from '../teams/list';
import LocationsList from '../locations/list';
import RolesList from '../roles/list';
import { PEOPLE } from '../../constants';

interface ISelectedItemsProps {
  selectedUsers: any[];
  selectedTeams: any[];
  selectedLocations: any[];
  selectedRoles: any[];
  selected: any[];
  customListProps: any;
  changeHandler: (option: any, all: boolean, type?: string) => void;
  changeHandlerLocations: any;
}

const ListItem = ({
  option,
  selected,
  changeHandler,
  customListProps,
  startIcon,
  endIconRenderer,
}) => (
  <CustomListItem
    checkbox={customListProps?.isMulti}
    styleSelected={
      !customListProps?.isMulti && customListProps?.showInlineSelection
    }
    key={option.id}
    id={option.id}
    selected={selected?.includes(option?.id)}
    onClick={() => {
      changeHandler(option?.id, false, PEOPLE);
    }}
    style={{ borderRadius: 6, padding: '0px 10px' }}
    startIcon={startIcon}
    checkboxProps={{
      style: {
        width: 18,
        height: 18,
      },
    }}
    endIcon={endIconRenderer}
  >
    <StyledName>{option.label}</StyledName>
  </CustomListItem>
);

const SelectedItems: FC<ISelectedItemsProps> = ({
  selectedUsers,
  selectedTeams,
  selectedLocations,
  selectedRoles,
  selected,
  customListProps,
  changeHandler,
  changeHandlerLocations,
}) => {
  return (
    <>
      {selectedUsers?.length > 0 && (
        <Stack>
          <Typography fontWeight={'600'} fontSize={'13px'} color="#616161">
            Selected Users
          </Typography>
          <Stack>
            {selectedUsers?.map((option, _) => {
              const { startIcon } = option;
              const endIconRenderer = <StatusChip user={option} />;
              return (
                <ListItem
                  key={option.id}
                  option={option}
                  selected={selected}
                  changeHandler={changeHandler}
                  customListProps={customListProps}
                  startIcon={startIcon}
                  endIconRenderer={endIconRenderer}
                />
              );
            })}
          </Stack>
        </Stack>
      )}

      {selectedTeams?.length > 0 && (
        <>
          <Title>Selected Teams</Title>
          <TeamsList
            data={selectedTeams}
            selected={selected}
            listProps={customListProps}
            changeHandler={changeHandler}
          />
        </>
      )}

      {selectedLocations?.length > 0 && (
        <>
          <Title>Selected Locations</Title>
          <LocationsList
            data={selectedLocations}
            selected={selected}
            changeHandler={changeHandlerLocations}
            listProps={{
              showSelectedOnly: true,
              isSearch: false,
              isSelectAll: false,
              hideActions: true,
            }}
          />
        </>
      )}

      {selectedRoles?.length > 0 && (
        <RolesList
          data={selectedRoles}
          selected={selected}
          listProps={{
            selectedListPlaceholder: 'Selected Roles',
            isSearch: false,
            isSelectAll: false,
            partition: true,
            hideActions: true,
          }}
          changeHandler={changeHandler}
        />
      )}
    </>
  );
};

export default SelectedItems;
